import { createFileRoute } from '@tanstack/react-router';
import { LotteryEmbedPage } from '../features/games/LotteryEmbedPage.js';

export const Route = createFileRoute('/_player/lottery/results')({
  component: LotteryResultsRoute,
});

function LotteryResultsRoute() {
  return <LotteryEmbedPage view={{ kind: 'results' }} />;
}
